import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs'; 
import { APIGEE_TOKEN_URL } from 'src/app/common/core/urls.mocks.constants';
 
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
 

  constructor( private http: HttpClient ) { 
    
  }

  createLog(message):Observable<any>{ 
    return this.http
    .post( APIGEE_TOKEN_URL.SPLUNK_LOG.path, message)
    .pipe(
      map((x:any) => x.data),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error.message);
      }),
    );  
  }
}
